import React from 'react'
import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
export default function () {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Navbar collapseOnSelect expand="lg" bg="white" variant="light"  className='mb-3'>
      <Container>
        <Navbar.Brand href="/"><img className=' logo  img-responsive' src='./logo.png'/></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        
          <Nav className="mx-auto main-nav">
            <Nav.Link href="/" className='mx-3 nav-item'>HOME</Nav.Link>
            <Nav.Link href="/werbenetzwerk" className='mx-3 nav-item'>WERBENETZWERK</Nav.Link>
            <Nav.Link href="/ueber-uns" className='mx-3 nav-item'>ÜBER UNS</Nav.Link>
            <Nav.Link href="/kontakt-formular" className='mx-3 nav-item'>KONTAKT</Nav.Link>
            <Nav.Link href="https://piiscreen.de/account/login" className='mx-3 nav-item'>LOGIN</Nav.Link>
            
          </Nav>
         
        
        <Button variant='light' onClick={handleShow} className="me-2">
        <i class="fa fa-bars" aria-hidden="true" ></i>
      </Button> 
      </Container>
      <Offcanvas show={show} onHide={handleClose}         placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <Nav className="mx-auto">
            <Nav.Link href="/" className='mx-1 canvas-item py-3  fs-6 hcolor'>Home</Nav.Link>
            <Nav.Link href="/werbenetzwerk" className='mx-1 canvas-item py-3 hcolor '>Werbenetzwerk</Nav.Link>
            <Nav.Link href="/ueber-uns" className='mx-1 py-3 canvas-item hcolor'>Über uns</Nav.Link>
            <Nav.Link href="/kontakt-formular" className='mx-1 py-3 canvas-item hcolor'>Kontakt</Nav.Link>
            <img src='./canvas-img.jpg' className='mx-auto w-100 canvas-item py-3'/>
            <p className='hcolor'><span className='fw-bold'>Pii</span>SCREEN Werbenetzwerk GmbH
Loebstraße 15 · 54292 Trier</p>
            <p><i className='fas fa-phone-square'></i><a href='tel:+496516034240' className='mx-1 canvas-link'>+49 651 6034240</a></p>
            <p><i className='fas fa-envelope-open'></i><a href="mailto:werbenetzwerk@piiscreen.de" className='mx-1 canvas-link'> werbenetzwerk@piiscreen.de</a></p>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </Navbar>
  )
}

